document.addEventListener("DOMContentLoaded", function() {
    invokeLineItemProp();
});

function invokeLineItemProp() {
    const saleMeta = document.getElementById('yala-sale-meta');
    const hasMetafieldDiscount = saleMeta?.dataset.hasMetafieldDiscount === 'true';

    document.querySelectorAll(".product-info__block-item").forEach(item => {
        if (item.getAttribute("data-block-type") !== "price") return;

        const priceList = item.querySelector("price-list");
        if (!priceList) return;

        const compareAtPrice = priceList.querySelector("compare-at-price");
        const discountPercent = getDiscountPercent(priceList);

        const isFinalSale      = compareAtPrice && !hasMetafieldDiscount;
        const isStoreCreditSale = hasMetafieldDiscount && discountPercent >= 30;

        // Always reset before re-applying so variant changes can't double up
        removeSaleBanner();
        removeStoreCreditBanner();
        removeLineItemProp();
        removeStoreCreditLineItemProp();

        if (isFinalSale) {
            appendBanner(priceList, "final-sale", "Final sale - no returns or exchanges");
            addLineItemProp();
        } else if (isStoreCreditSale) {
            appendBanner(priceList, "store-credit-sale", "Sale - Eligible for exchange or store credit");
            addStoreCreditLineItemProp();
        }
    });
}

function getDiscountPercent(priceList) {
    const parsePrice = (el) => {
        if (!el) return 0;
        const raw = el.textContent.replace(/[^\d.,]/g, '').replace(/,/g, '');
        return parseFloat(raw) || 0;
    };
    const sale    = parsePrice(priceList.querySelector("sale-price"));
    const compare = parsePrice(priceList.querySelector("compare-at-price"));
    if (!compare || compare <= sale) return 0;
    return ((compare - sale) / compare) * 100;
}

function appendBanner(parent, className, text) {
    const banner = document.createElement("div");
    banner.className = className;
    banner.textContent = text;
    parent.append(banner);
}

// --- line item properties ---

function addLineItemProp() {
    addBuyButtonsInput("finalSaleProp", "finalSale", "Final Sale", "No returns or exchanges.");
}

function addStoreCreditLineItemProp() {
    addBuyButtonsInput("saleItemProp", "saleItem", "Sale Item", "Exchange or Store Credit Only");
}

function addBuyButtonsInput(wrapperId, inputId, propertyName, value) {
    if (document.getElementById(wrapperId)) return;

    document.querySelectorAll(".product-info__block-item").forEach(item => {
        if (item.getAttribute("data-block-type") !== "buy-buttons") return;
        const productForm = item.querySelector('buy-buttons');
        if (!productForm) return;

        const propDiv = document.createElement("div");
        propDiv.id = wrapperId;
        propDiv.innerHTML = `<input type="text" id="${inputId}" class="Form__Textarea" value="${value}" name="properties[${propertyName}]" maxlength="200" hidden />`;
        productForm.append(propDiv);
    });
}

function removeLineItemProp()            { document.getElementById('finalSaleProp')?.remove(); }
function removeStoreCreditLineItemProp() { document.getElementById('saleItemProp')?.remove(); }
function removeSaleBanner()              { document.querySelector(".final-sale")?.remove(); }
function removeStoreCreditBanner()       { document.querySelector(".store-credit-sale")?.remove(); }

document.addEventListener("variant:change", function(event) {
    if (event.detail.variant) {
        invokeLineItemProp(); // handles its own cleanup now
    }
});